import {IUserPreviewProps} from "./UserPreview.interfaces";
import React, {useCallback, useContext, useEffect} from "react";
import {AppContext, IAppContextState} from "../../services/AppContext";
import {TokenModule} from "../../modules/Token.module";

export const useUserPreview = (props: IUserPreviewProps) => {
    const context = useContext<IAppContextState>(AppContext);

    const user = context.users.list.find(u => u.id === props.userId);

    useEffect(function onUserInitialized() {
        (async () => {
            if (!!user || !props.userId) return;
            await context.users.fetchUsers([props.userId]);
        })()
    }, [props.userId]);

    const isLightTheme = context.teams.isLightTheme;

    const isTouchScreen = context.teams.isTouchScreen;

    const isCurrentUser = props.userId === context.teams.userId;

    const handleDisconnect = useCallback(async () => {
        await TokenModule.signOut();
    }, []);

    return {
        ...props,
        user,
        isCurrentUser,
        isTouchScreen,
        isLightTheme,
        handleDisconnect
    }
}